<script setup lang="ts"></script>

<template>
  <div class="scanlines-global" aria-hidden="true"></div>
</template>

<style scoped>
.scanlines-global {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9998;
  background: repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.12) 0px,
    rgba(0, 0, 0, 0.12) 1px,
    transparent 1px,
    transparent 3px
  );
  opacity: 0.5;
}
</style>
